import { CombinedError } from '@/graphql';
import { AppError } from './AppError';

/**
 * Error thrown when network offline condition is detected.
 */
export class OfflineError extends AppError {
  constructor() {
    super({
      title: `It seems like you're offline`,
      message: 'Check your network connection, and then refresh your browser',
    });
    Object.setPrototypeOf(this, OfflineError.prototype);
  }
}

export function isOfflineError(error: Error) {
  return (
    error instanceof OfflineError ||
    /* fetch throws TypeError with failed to fetch message */
    (error instanceof TypeError && error.message === 'Failed to fetch') ||
    /* urql throws CombinedError with failed to fetch message */
    (error instanceof CombinedError && error.message === '[Network] Failed to fetch')
  );
}
